import { FC, ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import hasMemberIdCookie from 'utils/hasMemberIdCookie';
import QffUserContext, { QffUser } from './QffUserContext';
import { SelfServiceAPI } from 'apis';

interface Props {
  children: ReactNode;
}

const QffUserProvider: FC<Props> = ({ children }) => {
  const [qffUser, setQffUser] = useState<QffUser | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await SelfServiceAPI.getMember({ skipUnauthenticatedRedirection: true });
      setQffUser({ ...response, pointsBalance: response.pointsBalance?.toString() || '0' });
    } catch (e) {
      setQffUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!hasMemberIdCookie()) {
      return;
    }

    fetchData();
  }, [fetchData]);

  const value = useMemo(
    () => ({
      qffUser,
      isLoading: loading,
    }),
    [qffUser, loading],
  );

  return <QffUserContext.Provider value={value}>{children}</QffUserContext.Provider>;
};

export default QffUserProvider;
